import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import UserPreferencesService from '../../../services/UserPreferencesService';
import { updateListVariant } from '../../../redux/slices/ui/layout';
import useFeatureFlags from '../useFeatureFlags';
import FEATURE_FLAGS from '../../constants/featureFlags';

const userPreferenceService = UserPreferencesService.get();

const useUserPreferences = () => {
  const dispatch = useDispatch();
  const gridViewEnabled = useFeatureFlags(FEATURE_FLAGS.IS_GRID_VIEW_ENABLED);
  const listVariant = useSelector(state => state?.ui?.layout?.listVariant);

  useEffect(() => {
    const fetchPreference = async () => {
      const listPreference = await userPreferenceService.getListVariant();
      if (listPreference !== listVariant) {
        dispatch(updateListVariant(listPreference));
      }
    };
    // Only make API call to fetch user preference if grid view is enabled
    if (gridViewEnabled) {
      fetchPreference();
    }
    // eslint-disable-next-line
  }, []);
};

export default useUserPreferences;
